<script>
import render from '@/render/render'
import draggable from 'vuedraggable'
export default {
    name: 'Card',
    props: {
        rows: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: '卡片标题'
        },
        shadow: {
            type: String,
            default: 'always'
        }
    },
    data() {
        return {
            info: {}
        }
    },
    watch: {
        value: {
            handler(value) {
                if(Array.isArray(value)) {
                    // 转化数据为formData模式
                    value.map(item => {
                       this.info[item.key] = item.value
                    })
                }
            },
            immediate: true,
        }
    },
    render() {
        const { rows, title, shadow, info } = this
        const setValue = (value, key) => {
            console.log(value, key)
            const keys = Object.keys(this.info)
            const data = keys.map(key => {
                return {
                    key,
                    value: this.info[key]
                }
            })
            const hasItem = data.find(item => item.key === key)
            if(hasItem) {
                hasItem.value = value
            } else {
                data.push({key, value})
            }


            this.$emit('input', data)
        }
        const { design } = this.$attrs
        return (
            <el-card class="box-card" shadow={shadow}>
                <div slot="header">
                    <span>{title}</span>
                </div>
                {
                    design && this.$slots.default ? (
                        <draggable list={rows} group="componentsGroup">
                            { this.$slots.default }
                        </draggable>
                    ) : 
                    rows.map((item, index) => {
                        const { __vModel__, __config__: { span, showLabel, label } } = item
                        return (
                            <el-col span={span} style="padding: 10px 0">
                                <el-form-item label-width="120px" prop={__vModel__} label={showLabel ? label : ""}>
                                    <render info={info} conf={item} onInput={value => setValue(value, __vModel__)} attrs={this.$attrs} />
                                </el-form-item>
                            </el-col>
                        )
                    })
                }
            </el-card>
        )
    }
}
</script>